import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios"
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from 'react-redux';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    useAccount
} from "@azure/msal-react"

import {
    format,
    subHours,
    startOfMonth,
    endOfMonth,
    formatISO,
    subMonths,
    getYear,
    addMonths,
    parseISO,
    parse,
    toDate
} from 'date-fns';
import { enGB, cy } from 'date-fns/locale';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import SitePage from '../sitepage/SitePage';
import { Link, NavLink } from "react-router-dom";

function Committee(props) {
    const { t, i18n } = useTranslation();

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {})

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [meetings, setMeetings] = useState([]);
    const [meetingsPage, setMeetingsPage] = useState(1);
    const meetingsPerPage = 10;

    //const [date, setDate] = useState(startOfMonth(Date.now()));

    const language = useSelector((state) => state.language.value);

    useEffect(() => {
        console.log("useEffect:requestData:" + loading);
        if (!loading) {
            loadData();
            loadMeetings();
        }
    }, [language, props]);

    function loadMeetings() {
        setMeetings([])
        axios
            .create({
                /*headers: { Authorization: `Bearer ${response.accessToken}` }*/
            })
            .get(authConfig.api.urls.getMeetingList, {
                params: {
                    committeeid: props.id
                }
            })
            .then(function (response) {
                const allowedStatuses = ["scheduled", "published"];
                const filteredMeetings = response.data.filter((meeting) =>
                    meeting.status &&
                    allowedStatuses.includes(meeting.status.name.toLowerCase()) &&
                    meeting.isRestricted === false
                );
                setMeetings(filteredMeetings);
                setMeetingsPage(1);
            })
            .catch(function (error) {
                console.error(error)
            })
    }

    function loadData() {
        setError(null)
        setData([])
        if (isAuthenticated) {
            if (account && loading == false) {
                setLoading(true)
                instance
                    .acquireTokenSilent({
                        scopes: authConfig.api.scopes,
                        account: account
                    })
                    .then(response => {
                        if (response) {
                            console.log("Got access token:", response)
                            axios
                                .create({
                                    headers: { Authorization: `Bearer ${response.accessToken}` }
                                })
                                .get(authConfig.api.urls.getCommittee + "/" + props.id)
                                .then(function (response) {
                                    console.log(response.data);
                                    //response.data.outsideBodies.sort((a, b) => {
                                    //    return a.nameEn > a.nameEn;
                                    //});
                                    setData(response.data);
                                })
                                .catch(function (error) {
                                    setError("Error fetching data: " + error.message)
                                    console.error(error)
                                })
                                .then(function () {
                                    // always executed
                                    setLoading(false)
                                })
                        } else {
                            setError("Empty token??")
                            console.error("no token acquired")
                        }
                    })
                    .catch(error => {
                        setError("Error getting token: " + error.message)
                        console.error(error)
                        setLoading(false)
                    })
            } else {
                setError("No account...")
            }
        } else {
            axios
                .create({
                    /*headers: { Authorization: `Bearer ${response.accessToken}` }*/
                })
                .get(authConfig.api.urls.getCommittee + "/" + props.id)
                .then(function (response) {
                    console.log(response.data);
                    //response.data.outsideBodies.sort((a, b) => {
                    //    return a.nameEn > b.nameEn ? 1 : a.nameEn < b.nameEn ? -1 : 0;
                    //});
                    setData(response.data);
                })
                .catch(function (error) {
                    setError("Error fetching data: " + error.message)
                    console.error(error)
                })
                .then(function () {
                    // always executed
                    setLoading(false)
                })
        }
    }
    //
    function getFormattedDate(date) {
        if (date) {
            const parsedDate = new Date(date);
            const hasErroneousMidnightTime = parsedDate.getHours() === 0 && parsedDate.getMinutes() === 0;
            return format(
                parsedDate,
                hasErroneousMidnightTime ? "EEEE, do LLLL, yyyy" : "EEEE, do LLLL, yyyy h:mm bbb",
                { locale: i18n.language == 'en' ? enGB : cy });
        } else {
            return "";
        }
    }

    const totalMeetingPages = Math.max(1, Math.ceil(meetings.length / meetingsPerPage));
    const pagedMeetings = meetings.slice((meetingsPage - 1) * meetingsPerPage, meetingsPage * meetingsPerPage);

    return data === null || loading ?
        (<></>) :
        (
            <>
                <h1>{language === 'cy' ? data.nameCy : data.nameEn}</h1>
                <p>
                    <b>{t("Purpose of committee")}</b>
                </p>
                <div dangerouslySetInnerHTML={{ __html: language === 'cy' ? data.descriptionCy : data.descriptionEn }} />
                <p>
                    <b>{t("Membership")}</b>
                </p>
                <ul>
                    {
                        data.membership ? data.membership.map((member, index) => (
                            <li key={index}>
                                {member.person.member ?
                                    (
                                        <Link to={"/member/" + member.person.member.id}>{t(member.person.title) + " " + member.person.firstname + " " + member.person.lastname}</Link>
                                    )
                                    :
                                    (
                                        <>
                                            {t(member.person.title) + " " + member.person.firstname + " " + member.person.lastname}
                                        </>
                                    )
                                }
                                {member.role.trim() === "" ? '' : " (" + t(member.role) +")"}
                            </li>
                        )) : ''
                    }
                </ul>
                <p>
                    <b>{t("Meetings")}</b>
                </p>
                <Table bordered hover responsive>
                    <thead>
                        <tr>
                            <th>{t("Meeting")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Date")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            pagedMeetings.map((meeting, index) => (
                                <tr key={meeting.id} className={index % 2 === 0 ? "" : "table-light"}>
                                    <td>
                                        <Link to={"/meeting/" + meeting.id}>
                                            {language === 'cy' ? meeting.titleCy : meeting.titleEn}
                                        </Link>
                                    </td>
                                    <td>{meeting.status ? t(meeting.status.name) : ''}</td>
                                    <td>{getFormattedDate(meeting.start)}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
                {meetings.length > meetingsPerPage ? (
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="success"
                            size="sm"
                            disabled={meetingsPage === 1}
                            onClick={() => setMeetingsPage(meetingsPage - 1)}
                        >
                            &lt; {t("Previous")}
                        </Button>
                        <span>{t("Page")} {meetingsPage} {t("of")} {totalMeetingPages}</span>
                        <Button
                            variant="success"
                            size="sm"
                            disabled={meetingsPage === totalMeetingPages}
                            onClick={() => setMeetingsPage(meetingsPage + 1)}
                        >
                            {t("Next")} &gt;
                        </Button>
                    </div>
                ) : ''}
                <p>
                    <b>{t("Contact Information")}</b>
                </p>
                <div dangerouslySetInnerHTML={{ __html: language === 'cy' ? data.contactCy : data.contactEn}} />
            </>
        );
}
export default Committee;
